import demo from '../assets/icons/demo.svg'
// Icons
import treatmentStartFuturesIcon from '../assets/images/treatmentStartFuturesIcon.png'
import treatmentPlanStateIcon from '../assets/images/treatmentPlanStateIcon.png'
import imagePdf from '../assets/images/iconPDF.png'

import calenderComingSoon from '../assets/images/calenderComingSoon.png'
import SendEmailIImage from '../assets/images/SendEmailIImage.png'
import invitePatient from '../assets/images/invitePatient.png'
import onboardSuccess from '../assets/images/onboardSuccess.png'
import dashboardDesign from '../assets/images/dashboardDesign.png'
import imagePatientDefault from '../assets/images/imagePatientDefault.png'
import invitePatientSent from '../assets/images/InviteSentImage.png'
import ImageComingSoonCalender from '../assets/images/ImageComingSoonCalender.png'
import imageFolder from '../assets/images/Folder.png'
import disabledImageFolder from '../assets/images/DisabledFolder.png'
import blog1 from '../assets/images/blog/blog1.jpg'
import blog2 from '../assets/images/blog/blog2.jpg'
import blog3 from '../assets/images/blog/blog3.jpg'
import blog4 from '../assets/images/blog/blog4.jpg'
import blog5 from '../assets/images/blog/blog5.jpg'

import setupTreatmentPlanSuccessImage from '../assets/images/setupTreatmentPlanSuccessImage.png'
import treatmentNotStarted from '../assets/images/treatmentNotStarted.png'
import NoUpdates from '../assets/images/NoUpdates.png'
import productionScreenEmptyState from '../assets/images/ProductionScreenEmptyState.png'
import notesModalEmptyState from '../assets/images/notesModalEmptyState.png'
import emptyStateManWithLap from '../assets/images/emptyStateManWithLap.png'
import doctorHoldingTooth from '../assets/images/Dentist holding a tooth model.png'
import searchEmptyState from '../assets/images/searchEmptyState.png'
import imageComingSoon from '../assets/images/IMAGE_COMING_SOON.jpg'
import subscribePng from '../assets/images/subscribePng.png'
import appointmentsComingSoon from '../assets/images/appointmentsComingSoon.png'
import dashboardEmptyState from '../assets/images/dashboardEmptyState.png'
import pendingPatientsEmptyState from '../assets/images/pendingPatientsEmptyState.png'
import notificationEmptyState from '../assets/images/notificationEmptyState.png'
import noPaymentAdded from '../assets/images/NoPaymentAdded.png'
import promotionBanner from '../assets/images/promotionBanner.png'
import noPatientsFound from '../assets/images/NoPatientsFound.png'
import Left from '../assets/images/leftSideFace.png'
import Right from '../assets/images/rightSideFace.png'
import Top from '../assets/images/topSideAligner.png'
import Front from '../assets/images/frontFaceAligner.png'
import FrontWithSmile from '../assets/images/FrontFaceWithSmile.png'
import Both from '../assets/images/BothSideAligner.png'
import Bite from '../assets/images/BiteIntra.png'
import lowerIntra from '../assets/images/LowerIntra.png'
import upperIntra from '../assets/images/UpperIntra.png'
import rightIntra from '../assets/images/RightIntra.png'
import leftIntra from '../assets/images/LeftIntra.png'
import treatmentEmptyStatus from '../assets/images/treatmentEmptyStatus.png'
import getBrandConfig from './getBrandConfig'
import RightSide from '../assets/images/RightSide.png'
import FrontSide from '../assets/images/FrontSide.png'
import LeftSide from '../assets/images/LeftSide.png'
import star_image from '../assets/images/star_image.png'
import stl_lower from '../assets/images/stl_lower.png'
import stl_upper from '../assets/images/stl_upper.png'
import stl_front_one from '../assets/images/stl_front_one.png'
import stl_front_two from '../assets/images/stl_front_two.png'
import xray_opg from '../assets/images/xray_opg.png'
import xray_cephalomentric from '../assets/images/xray_cephalometric.png'
import right_without_smile from '../assets/images/image (1).png'
import left_without_smile from '../assets/images/image (2).png'
import straight_smile from '../assets/images/image (3).png'
import straight_without_smile from '../assets/images/Frontal Photo.png'
import dicomImage from '../assets/images/dicom.png'

export const DEMO = demo

// BLog
export const IMAGE_BLOG1 = blog1
export const IMAGE_BLOG2 = blog2
export const IMAGE_BLOG3 = blog3
export const IMAGE_BLOG4 = blog4
export const IMAGE_BLOG5 = blog5

// IMAGES
export const IMAGE_LOGO = getBrandConfig().logo
export const IMAGE_SENT = SendEmailIImage
export const IMAGE_INVITE_PATIENT = invitePatient
export const IMAGE_DASHBOARD_TILE = dashboardDesign
export const IMAGE_CALENDER_COMING_SOON = calenderComingSoon
export const IMAGE_ONBOARD_SUCCESS = onboardSuccess
export const IMAGE_DEFAULT_PATIENT = imagePatientDefault
export const IMAGE_INVITE_PATIENT_SENT_SUCCESS = invitePatientSent
export const IMAGE_FOLDER = imageFolder
export const DISABLED_IMAGE_FOLDER = disabledImageFolder
export const IMAGE_COMING_SOON_CALENDER = ImageComingSoonCalender

export const IMAGE_SETUP_TREATMENT_PLAN = setupTreatmentPlanSuccessImage
export const IMAGE_TREATMENT_NOT_STATED = treatmentNotStarted
export const IMAGE_TREATMENT_START_FUTURE = treatmentStartFuturesIcon
export const IMAGE_TREATMENT_STATE = treatmentPlanStateIcon
export const IMAGE_PDF = imagePdf
export const IMAGE_NO_UPDATE = NoUpdates
export const IMAGE_EMPTY_STATE = emptyStateManWithLap
export const IMAGE_COMING_SOON = imageComingSoon

// Sidebar Menu Icon
export const IMAGE_APP_LOGO = getBrandConfig().logo
export const IMAGE_SEARCH_EMPTY_STATE = searchEmptyState

//Production
export const IMAGE_PRODUCTION_SCREEN_EMPTY_STATE = productionScreenEmptyState
export const IMAGE_NOTES_MODAL_EMPTY_STATE = notesModalEmptyState

export const IMAGE_DENTIST_HOLDING_TOOTH = doctorHoldingTooth
export const IMAGE_SUBSCRIBE = subscribePng
export const IMAGE_APPOINTMENTS_COMING_SOON = appointmentsComingSoon
export const IMAGE_DASHBOARD_EMPTY_STATE = dashboardEmptyState
export const IMAGE_EMPTY_STATE_PENDING_PATIENTS = pendingPatientsEmptyState
export const IMAGE_EMPTY_STATE_NOTIFICATION = notificationEmptyState

export const IMAGE_NO_PAYMENT_ADDED = noPaymentAdded
export const IMAGE_PROMOTION_BANNER = promotionBanner
export const IMAGE_NO_PATIENTS_FOUND = noPatientsFound

export const RIGHT_SIDE_VIEW = Left
export const LEFT_SIDE_VIEW = Right
export const FRONT_VIEW = Front
export const FRONT_VIEW_WITH_SMILE = FrontWithSmile
export const BOTTOM_VIEW = Both
export const TOP_VIEW = Top
export const INTRA_ORAL_UPPER = upperIntra
export const INTRA_ORAL_LOWER = lowerIntra
export const INTRA_ORAL_RIGHT = rightIntra
export const INTRA_ORAL_LEFT = leftIntra
export const INTRA_ORAL_BITE = Bite
export const TREATMENT_EMPTY_STATUS = treatmentEmptyStatus

export const RIGHT_SIDE_SMILE_SIMULATION = RightSide
export const FRONT_SIDE_SMILE_SIMULATION = FrontSide
export const LEFT_SIDE_SMILE_SIMULATION = LeftSide
export const IMAGE_STAR = star_image

export const STL_LOWER = stl_lower
export const STL_UPPER = stl_upper
export const STL_FRONT_ONE = stl_front_one
export const STL_FRONT_TWO = stl_front_two
export const XRAY_OPG = xray_opg
export const XRAY_CEPHALOMETRIC = xray_cephalomentric

// Extraoral photograph examples
export const EXTRAORAL_RIGHT_WITHOUT_SMILE = right_without_smile
export const EXTRAORAL_STRAIGHT_WITHOUT_SMILE = straight_without_smile
export const EXTRAORAL_LEFT_WITHOUT_SMILE = left_without_smile
export const EXTRAORAL_STRAIGHT_SMILING = straight_smile
export const DIACOM_IMAGE = dicomImage
